import { mainAPIUrl } from '../../../settings';

const baseURL = `${mainAPIUrl}/gservices_3/ss`;

/**
 * Generate a deep link for the user to continue SmartSend in the Gesture app
 * Endpoint: POST /gservices_3/ss/smartsend/deep_link
 *
 * @param {string} orderId - The order ID
 * @param {string} phoneNumber - Phone number in E.164 format (e.g., "+14155552671")
 * @returns {Promise<{success: boolean, deepLinkUrl?: string, error?: string}>}
 */
export const generateDeepLink = async (orderId, phoneNumber) => {
  if (!orderId || !phoneNumber) {
    return {
      success: false,
      error: 'Missing required parameters',
    };
  }

  try {
    const url = `${baseURL}/smartsend/deep_link`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        orderId,
        phoneNumber,
      }),
    });

    const json = await response.json();

    if (!response.ok) {
      const message =
        json.error || json.message || 'Failed to generate deep link. Please try again.';

      return {
        success: false,
        error: message,
      };
    }

    const deepLinkUrl = json.deepLinkUrl || json.data?.deepLinkUrl;

    if (!deepLinkUrl) {
      return {
        success: false,
        error: 'Deep link is missing from the response.',
      };
    }

    return {
      success: true,
      deepLinkUrl,
    };
  } catch (error) {
    console.error('Error generating deep link:', error);
    return {
      success: false,
      error: 'Network error. Please check your connection and try again.',
    };
  }
};
